(() => {
  const init = (root) => {
    if (!root || root.dataset.ready) return;
    const slides = [...root.querySelectorAll('.vr-monitor__slide')];
    const dots = [...root.querySelectorAll('[data-vr-dot]')];
    if (!slides.length) return;
    root.dataset.ready = 'true';
    let index = 0, timer;
    const show = (next) => {
      index = (next + slides.length) % slides.length;
      slides.forEach((s,i) => s.classList.toggle('is-active', i === index));
      dots.forEach((d,i) => d.classList.toggle('is-active', i === index));
    };
    const play = () => { clearInterval(timer); timer = setInterval(() => show(index + 1), 5500); };
    root.querySelector('[data-vr-prev]')?.addEventListener('click', () => { show(index - 1); play(); });
    root.querySelector('[data-vr-next]')?.addEventListener('click', () => { show(index + 1); play(); });
    dots.forEach(d => d.addEventListener('click', () => { show(Number(d.dataset.vrDot)); play(); }));
    root.addEventListener('mouseenter', () => clearInterval(timer));
    root.addEventListener('mouseleave', play);
    play();
  };

  const setLink = (link, href, label) => {
    if (!link) return;
    link.href = href;
    link.textContent = 'Ver loja →';
    link.setAttribute('aria-label', label);
  };

  const ensureLegacyLink = (card, href, label) => {
    if (!card) return;
    const body = card.querySelector('div') || card;
    let link = body.querySelector('.vr-store-page');
    if (!link) {
      link = document.createElement('a');
      link.className = 'vr-store-page';
      body.appendChild(link);
    }
    setLink(link, href, label);
  };

  const ensureGoogleRating = (card, score, count, href, label) => {
    if (!card) return;
    const body = card.querySelector('div') || card;
    let rating = body.querySelector('.vr-store-rating');
    if (!rating) {
      rating = document.createElement('a');
      rating.className = 'vr-store-rating';
      body.appendChild(rating);
    }
    rating.href = href;
    rating.target = '_blank';
    rating.rel = 'noopener noreferrer';
    rating.setAttribute('aria-label', label);
    rating.innerHTML = `<span class="vr-store-rating__google">Google</span><strong><b>${score}</b><i aria-hidden="true">★★★★★</i></strong><small>${count} avaliações</small><em>Ver críticas →</em>`;
  };

  const updateStoreLinks = (scope = document) => {
    const cards = scope.querySelectorAll('.vr-store-grid > div');
    if (cards[0]) setLink(cards[0].querySelector('a'), '/pages/loja-verderena?view=loja-verderena', 'Ver loja VR Informática Verderena');
    if (cards[1]) setLink(cards[1].querySelector('a'), '/pages/loja-baixa-da-banheira?view=loja-baixa-da-banheira', 'Ver loja VR Informática Baixa da Banheira');

    const legacy = scope.querySelectorAll('.vrp-stores article');
    ensureLegacyLink(legacy[0], '/pages/loja-verderena?view=loja-verderena', 'Ver loja VR Informática Verderena');
    ensureLegacyLink(legacy[1], '/pages/loja-baixa-da-banheira?view=loja-baixa-da-banheira', 'Ver loja VR Informática Baixa da Banheira');

    const bxbPhone = legacy[1]?.querySelector('a[href^="tel:"]');
    if (bxbPhone) {
      bxbPhone.href = 'tel:+351215500750';
      bxbPhone.textContent = '+351 21 550 0750';
    }

    ensureGoogleRating(
      legacy[0],
      '4,2',
      '27',
      'https://www.google.com/maps/search/?api=1&query=VR%20Informatica%20Verderena&query_place_id=ChIJxTd5qpc3GQ0RgxsxWioOS0E',
      'Ver avaliações Google da VR Informática Verderena'
    );

    ensureGoogleRating(
      legacy[1],
      '4,1',
      '13',
      'https://www.google.com/search?q=VR+Inform%C3%A1tica+Baixa+da+Banheira+avalia%C3%A7%C3%B5es',
      'Ver avaliações Google da VR Informática Baixa da Banheira'
    );
  };

  const tickerMessage = 'VR INFO  ✦  A reparar equipamentos desde 2015  ✦  LOJA VERDERENA · 914 950 104  ✦  BAIXA DA BANHEIRA · 21 550 0750  ✦  Diagnóstico rigoroso antes de reparar  ✦  Recondicionados VR com 3 anos de garantia  ✦  LOJA ONLINE · produtos · peças · acessórios · tecnologia  ✦  Reparação de computadores · smartphones · consolas · televisores  ✦  Troca de ecrãs · baterias · conectores  ✦  Faça backup regular dos seus dados  ✦  Enviamos para todo o país  ✦  Assistência técnica especializada VR  ✦  ';

  const initTopTicker = (scope = document) => {
    const wraps = scope.matches?.('.vrp-nav .vrp-wrap')
      ? [scope]
      : [...scope.querySelectorAll?.('.vrp-nav .vrp-wrap') || []];

    wraps.filter(wrap => wrap.closest('.vrp')).forEach(wrap => {
      if (wrap.querySelector('.vrp-ticker')) return;

      const ticker = document.createElement('div');
      ticker.className = 'vrp-ticker';
      ticker.setAttribute('role', 'region');
      ticker.setAttribute('aria-label', 'Informação VR');

      const track = document.createElement('div');
      track.className = 'vrp-ticker__track';

      const first = document.createElement('span');
      first.className = 'vrp-ticker__item';
      first.textContent = tickerMessage;

      const second = document.createElement('span');
      second.className = 'vrp-ticker__item';
      second.textContent = tickerMessage;
      second.setAttribute('aria-hidden', 'true');

      track.append(first, second);
      ticker.appendChild(track);

      const help = wrap.querySelector('.vrp-help');
      wrap.insertBefore(ticker, help || null);
    });
  };

  const desktopCardArt = {
    '/collections/all-in-one': {
      src: 'https://cdn.shopify.com/s/files/1/1010/1293/0942/files/vr-desktop-all-in-one-card-3d-2026-v2.png?v=1788649266&width=720',
      alt: 'All-In-One — VR Informática'
    },
    '/collections/mini-pc': {
      src: 'https://cdn.shopify.com/s/files/1/1010/1293/0942/files/vr-desktop-mini-pc-card-3d-2026-v2.png?v=1788649292&width=720',
      alt: 'Mini PC — VR Informática'
    },
    '/collections/monitores': {
      src: 'https://cdn.shopify.com/s/files/1/1010/1293/0942/files/vr-desktop-monitores-card-3d-2026.png?v=1788648722&width=720',
      alt: 'Monitores — VR Informática'
    },
    '/collections/pc-gaming': {
      src: 'https://cdn.shopify.com/s/files/1/1010/1293/0942/files/vr-desktop-pc-gaming-card-3d-2026-v2.png?v=1788649303&width=720',
      alt: 'PC Gaming — VR Informática'
    },
    '/collections/recondicionados-desktop': {
      src: 'https://cdn.shopify.com/s/files/1/1010/1293/0942/files/vr-desktop-recondicionados-card-3d-2026.png?v=1788648745&width=720',
      alt: 'Desktop Recondicionados — VR Informática'
    },
    '/collections/recondicionados-mini-pc': {
      src: 'https://cdn.shopify.com/s/files/1/1010/1293/0942/files/vr-desktop-mini-pc-recondicionados-card-3d-2026.png?v=1788648756&width=720',
      alt: 'Mini PC Recondicionados — VR Informática'
    },
    '/collections/recondicionados-all-in-one': {
      src: 'https://cdn.shopify.com/s/files/1/1010/1293/0942/files/vr-desktop-all-in-one-recondicionados-card-3d-2026.png?v=1788648767&width=720',
      alt: 'All-In-One Recondicionados — VR Informática'
    }
  };

  const desktopCardArtByIndex = [
    desktopCardArt['/collections/all-in-one'],
    desktopCardArt['/collections/mini-pc'],
    desktopCardArt['/collections/monitores'],
    desktopCardArt['/collections/pc-gaming'],
    desktopCardArt['/collections/recondicionados-desktop'],
    desktopCardArt['/collections/recondicionados-mini-pc'],
    desktopCardArt['/collections/recondicionados-all-in-one']
  ];

  const ensureDesktopCardStyles = () => {
    if (document.getElementById('vr-desktop-art-style')) return;
    const style = document.createElement('style');
    style.id = 'vr-desktop-art-style';
    style.textContent = `
      .vr-desktop-art-active .vrh-card.vrh-card--art{aspect-ratio:4/3;min-height:0!important;padding:0!important;border:1px solid #168fff;border-radius:15px;background:#031020;box-shadow:0 18px 40px #0008,0 0 24px #087dff33;overflow:hidden}
      .vr-desktop-art-active .vrh-card.vrh-card--art:before{display:none!important}
      .vr-desktop-art-active .vrh-card.vrh-card--art .vrh-visual{display:block;height:100%!important;min-height:0!important;flex:1 1 auto;background:#031020;overflow:hidden}
      .vr-desktop-art-active .vrh-card.vrh-card--art .vrh-visual:after{display:none!important}
      .vr-desktop-art-active .vrh-card.vrh-card--art .vrh-visual img{display:block;width:100%!important;height:100%!important;padding:0!important;object-fit:cover!important;filter:none!important;transform:none;transition:transform .35s ease,filter .35s ease}
      .vr-desktop-art-active .vrh-card.vrh-card--art:hover{transform:translateY(-7px) rotateX(1.5deg);border-color:#47cfff;box-shadow:0 28px 55px #0009,0 0 34px #087dff55}
      .vr-desktop-art-active .vrh-card.vrh-card--art:hover .vrh-visual img{transform:scale(1.025);filter:brightness(1.035)!important}
      .vr-desktop-art-active .vrh-card.vrh-card--art .vrh-copy,.vr-desktop-art-active .vrh-card.vrh-card--art .vrh-arrow{display:none!important}
      .vr-desktop-art-active .vrh-card.vrh-card--pending.vrh-card--art{opacity:1;border-style:solid}
      @media(max-width:650px){.vr-desktop-art-active .vrh-card.vrh-card--art{min-height:0!important}}
      @media(max-width:480px){.vr-desktop-art-active .vrh-grid{grid-template-columns:1fr!important}.vr-desktop-art-active .vrh-card.vrh-card--art{max-width:430px;width:100%;margin-inline:auto}}
    `;
    document.head.appendChild(style);
  };

  const initDesktopCards = (scope = document) => {
    if (window.location.pathname.replace(/\/$/, '') !== '/collections/computadores-desktop') return;
    document.body.classList.add('vr-desktop-art-active');
    ensureDesktopCardStyles();

    const root = scope.closest?.('.vrh') || scope.querySelector?.('.vrh') || document.querySelector('.vrh');
    const cards = root ? [...root.querySelectorAll('.vrh-grid > .vrh-card')] : [];

    cards.forEach((card, index) => {
      let path = '';
      if (card.tagName === 'A' && card.href) {
        path = new URL(card.href, window.location.origin).pathname.replace(/\/$/, '');
      }

      const art = desktopCardArt[path] || desktopCardArtByIndex[index];
      if (!art) return;

      card.classList.add('vrh-card--art');
      card.dataset.vrDesktopArt = 'true';
      const visual = card.querySelector('.vrh-visual');
      if (!visual) return;

      let img = visual.querySelector('img');
      if (!img) {
        visual.innerHTML = '';
        img = document.createElement('img');
        visual.appendChild(img);
      }
      img.src = art.src;
      img.alt = art.alt;
      img.loading = index < 4 ? 'eager' : 'lazy';
      img.decoding = 'async';
      img.width = 720;
      img.height = 540;
    });
  };

  const shopMenuCardArt = {
    '/collections/portateis': {
      src: 'https://cdn.shopify.com/s/files/1/1010/1293/0942/files/vr-loja-online-portateis-card-3d-2026.png?v=1788650001&width=900',
      alt: 'Portáteis — VR Loja Online'
    },
    '/collections/componentes-informatica': {
      src: 'https://cdn.shopify.com/s/files/1/1010/1293/0942/files/vr-loja-online-componentes-card-3d-2026.png?v=1788650014&width=900',
      alt: 'Componentes — VR Loja Online'
    },
    '/collections/equipamentos-recondicionados-vr': {
      src: 'https://cdn.shopify.com/s/files/1/1010/1293/0942/files/vr-loja-online-recondicionados-card-3d-2026.png?v=1788650036&width=900',
      alt: 'Recondicionados — VR Loja Online'
    },
    '/collections/empresas': {
      src: 'https://cdn.shopify.com/s/files/1/1010/1293/0942/files/vr-loja-online-empresas-card-3d-2026.png?v=1788650024&width=900',
      alt: 'Empresas — VR Loja Online'
    }
  };

  const ensureShopMenuArtStyles = () => {
    if (document.getElementById('vr-shop-menu-art-style')) return;
    const style = document.createElement('style');
    style.id = 'vr-shop-menu-art-style';
    style.textContent = `
      .vrl-card.vrl-card--premium-art{border-color:#168fff;background:#031020;box-shadow:0 10px 28px #0008,0 0 20px #087dff28}
      .vrl-card.vrl-card--premium-art .vrl-shade,
      .vrl-card.vrl-card--premium-art .vrl-card-copy,
      .vrl-card.vrl-card--premium-art .vrl-arrow{display:none!important}
      .vrl-card.vrl-card--premium-art img{object-fit:cover!important;filter:none!important}
      .vrl-card.vrl-card--premium-art:hover{border-color:#55d7ff;box-shadow:0 18px 38px #0009,0 0 32px #087dff50}
      .vrl-card.vrl-card--premium-art:hover img{transform:scale(1.025)}
    `;
    document.head.appendChild(style);
  };

  const initShopMenuCards = (scope = document) => {
    if (window.location.pathname.replace(/\/$/, '') !== '/collections') return;
    ensureShopMenuArtStyles();

    const cards = scope.matches?.('.vrl-card')
      ? [scope]
      : [...scope.querySelectorAll?.('.vrl-card') || []];

    cards.forEach(card => {
      const path = new URL(card.href || '', window.location.origin).pathname.replace(/\/$/, '');
      const art = shopMenuCardArt[path];
      if (!art) return;

      const img = card.querySelector('img');
      if (!img) return;

      card.classList.add('vrl-card--premium-art');
      img.src = art.src;
      img.alt = art.alt;
      img.loading = 'eager';
      img.decoding = 'async';
      img.width = 900;
      img.height = 675;
    });
  };

  const start = (scope = document) => {
    scope.querySelectorAll('[data-vr-monitor]').forEach(init);
    updateStoreLinks(scope);
    initTopTicker(scope);
    initDesktopCards(scope);
    initShopMenuCards(scope);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start());
  else start();
  document.addEventListener('shopify:section:load', e => start(e.target));
})();
